import { render, staticRenderFns } from "./CardMaquina.vue?vue&type=template&id=89d1bc2a&scoped=true&"
import script from "./CardMaquina.vue?vue&type=script&lang=js&"
export * from "./CardMaquina.vue?vue&type=script&lang=js&"
import style0 from "./CardMaquina.vue?vue&type=style&index=0&id=89d1bc2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d1bc2a",
  null
  
)

export default component.exports